/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import * as React from "react";

/**
 * The properties to be specified for a Placeholder component.
 */

/**
 * A simpler placeholder component to be shown when a value isn't present.
 */
export const AbPlaceholder = props => {
  const commonProps = ReactUtils.componentProps("ab-placeholder", props);
  if (props.placeholder) {
    return /*#__PURE__*/React.createElement("div", commonProps, props.placeholder);
  }
  return /*#__PURE__*/React.createElement("div", commonProps, "\xA0");
};
//# sourceMappingURL=AbPlaceholder.js.map
